import { Observable } from 'rxjs';

export abstract class LufcCustomerRegisterAdapter {
  abstract addLufcId(lufcId: string): Observable<string>;
  abstract getLufcId(): Observable<string>;
}
